"use strict";import{FieldGroup as e}from"./src/FieldGroup.js";customElements.define("sp-field-group",e);
//# sourceMappingURL=sp-field-group.js.map
